<template>
    <rkm-area title="Materiais">
        <template v-if="isModoPadrao || isSaved">
            <PadraoForm
                v-if="!isSaved"
                :data="data"
                ref="PadraoForm"
            />

            <PadraoList
                :data="data"
                :is-saved="isSaved"
                ref="PadraoList"
            />
        </template>

        <SequencialList
            v-else
            :data="data"
            ref="SequencialList"
        />
    </rkm-area>
</template>

<script>
// Components.
import PadraoForm from './components/padrao/Form'
import PadraoList from './components/padrao/List'
import SequencialList from './components/sequencial/List'

// Others.
import { repository, error } from '@/mixins'
import { mapActions } from 'vuex'

export default {
    components: {
        PadraoForm,
        PadraoList,
        SequencialList
    },
    created() {

        this.repositories = {
            requisicao: this.getConectaSusRepository('almoxarifado.requisicaoAberturaFechamento')
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        async validate() {

            if (this.isSaved) {

                return await this.$refs.PadraoList.validate()
            }
            else if (this.isModoPadrao) {

                const isValid = this.data.model.itens.length > 0

                if (!isValid) {

                    this.showValidationNotification('Obrigatório incluir pelo menos um material.')
                }

                return isValid
            }

            const isValid = !!this.data.model.itens
                .find(i => !!i.materiais.find(m => !isNaN(parseInt(m.quantidade)) && parseInt(m.quantidade) > 0))

            if (!isValid) {

                this.showValidationNotification('Obrigatório informar a quantidade de pelo menos um material.')
            }

            return isValid && await this.$refs.SequencialList.validate()
        },
        loadMateriais() {

            this.setLoading()

            this.repositories.requisicao.getMateriaisPermitidos(this.data.model.centroCustoId)
                .then(({ data }) => this.data.model.itens = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error],
    props: {
        data: { type: Object, required: true },
        isSaved: { type: Boolean, required: true },
        isModoPadrao: { type: Boolean, required: true },
    },
    watch: {
        'data.model.centroCustoId': function (centroCustoId) {

            if (this.isModoPadrao) {

                if (!centroCustoId) {

                    this.$refs.PadraoForm.resetForm()
                }
            }
            else {

                if (centroCustoId) {

                    this.loadMateriais()

                    return
                }

                this.data.model.itens = []
            }
        },
        isModoPadrao(isModoPadrao) {

            if (isModoPadrao) {

                this.data.model.itens = []
            }
            else if (this.data.model.centroCustoId) {

                this.loadMateriais()
            }
        }
    }
}
</script>